import { DialogService } from '@ansys-internal/awf-angular/shared';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { AWFMenu, AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ProjectData } from '@ansys/cloud-angular-client';
import {
  INSTANCE_TITLE,
  ProjectCreateFileMenu,
} from '@ansys-internal/awf-angular/dashboard';
import { CreateConceptFromFileDialogComponent } from '../../../components/dialogs/create-concept-from-file-dialog/create-concept-from-file-dialog.component';
import { AndromedaMenuItem } from '@ansys-internal/awf-angular/contributions';
import { ContributionsEnum } from '../../contributions.enum';
import { inject, Inject } from '@angular/core';

@AWFMenuItem({
  id: ContributionsEnum.IMPORT_FROM_FILE_MENU_ITEM,
  priority: 150,
})
export class ImportFromFileMenu implements AndromedaMenuItem {
  id = ContributionsEnum.IMPORT_FROM_FILE_MENU_ITEM;
  type = ContributionsEnum.IMPORT_FROM_FILE_MENU_ITEM;
  prefixIcon = { icon: Icons.FOLDER };
  tooltip: string;
  text: string;
  priority = 150;
  private dialogService = inject(DialogService);
  private instanceTitle = inject(INSTANCE_TITLE)

  constructor() {
    this.text = this.tooltip = `${this.instanceTitle} From File`;
  }

  execute(context: ProjectData): Promise<unknown> {
    return new Promise<void>((resolve) => {
      this.dialogService.open(CreateConceptFromFileDialogComponent, {
        title: `Create ${this.instanceTitle}`,
        data: {
          projectId: context.projectId,
        },
      });
      resolve();
    });
  }
}
